module.exports = __webpack_public_path__ + "static/media/fontDesk_FS.928a66e7.jpg";